<div class="container">
  <div class="row">
    <div class="col-sm-1"></div>
    <div class="col-sm-10">
      <form class="form-inline active-cyan-4">
        <input class="form-control form-control-sm mr-3 w-75" type="text"
          placeholder="Enter Github Username here ..." name="searchName"
          [(ngModel)]="searchName" aria-label="Search">
        <button type="submit" class="btn btn-info  btn-sm" (click)="search()"> <i class="fa fa-search"
            aria-hidden="true"></i> Search</button>
      </form>
    </div>
    <div class="col-sm-1"></div>
  </div>
</div>